import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { ToastContainer } from '../ui/Toast';
import { OfflineIndicator } from '../ui/OfflineIndicator';
import { useAppStore } from '../../stores/appStore';

export const Layout: React.FC = () => {
  const { isOnline } = useAppStore();

  return (
    <div className="min-h-screen bg-saavi-100/40">
      <Header />
      <OfflineIndicator />
      
      <main className="pb-20 sm:pb-24 min-h-screen">
        <Outlet />
      </main>
      
      <Navigation />
      <ToastContainer />
    </div>
  );
};